import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import CalendarComponent from "../../React_Components/CalendarComponen";
import TrackerButtons from "../Tracker_Common/TrackerButtons";
import { FaEdit, FaTrash } from 'react-icons/fa'; // React Icons for edit
import RemainderModal from "../Tracker_Common/Remainder";
import { Endpoints } from "../../../Global/Endpoints";
import { useTranslation } from 'react-i18next';
import { toast } from "react-toastify";
import ErrorModal from "../../Security/ErrorModal";

const Pregnancy=()=>
{
  const { t, i18n } = useTranslation();
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [remainders, setRemainders] = useState([]);
  const [notes, setNotes] = useState([]);
  const [reminderList, setReminderList] = useState([]);
  const [editData, setEditData] = useState(null);
  const email = useSelector((state) => state.email.email);
  const [isModalOpen, setModalOpen] = useState(false);
  const token = localStorage.getItem("AccessToken");
  const navigate=useNavigate();
  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";
  const deviceType = isHighmarkPortal ? "HighmarkPortal" : "PatientPortal";
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] = useState(false);
  const [deletingReminder, setDeletingReminder] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMenstrualCycleData = async (date) => {
    const currentDate = date.toLocaleDateString("en-US");
    const params = { EmailID: email, Date: currentDate,DeviceType: deviceType};
    setLoading(true);
    try {
      const response = await axios.post(
        Endpoints.LoadMenstrualCycleCalendarData,
        `_Params=${encodeURIComponent(JSON.stringify(params))}`,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data) {
        setRemainders(response.data.ReminderDate ? response.data.ReminderDate.split(",") : []);
        setNotes(response.data.EventDate ? response.data.EventDate.split(",") : []);
      }
    } catch (error) {
      console.error("Error fetching menstrual cycle data:", error);
    } finally {
      setLoading(false); 
    }
  };
  const fetchReminders = async (date) => {
    const formattedDate = date.toLocaleDateString("en-US");
    const params = { EmailID: email, Date: formattedDate,DeviceType: deviceType };

    try {
      const response = await axios.post(
       Endpoints.LoadReminderEventData,
        `_Params=${encodeURIComponent(JSON.stringify(params))}`,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data && response.data.Reminders) {
        const mappedReminders = response.data.Reminders.map(reminder => ({
          ReminderID: reminder.ReminderID,
          ReminderTitle: reminder.ReminderTitle,
          StartTime: new Date(reminder.StartTime), // Ensure this is a Date object
          EndTime: new Date(reminder.EndTime), // Ensure this is a Date object
        }));
        setReminderList(mappedReminders);
      }
    } catch (error) {
      console.error("Error fetching reminders:", error);
    }
  };

  useEffect(() => {
        if (typeof window !== "undefined") {
        window.resetCalendarGlobals?.();
      }
      }, []);

  useEffect(() => {
    fetchMenstrualCycleData(currentMonth);
    fetchReminders(selectedDate);
  }, [currentMonth, selectedDate, email, deviceType, token]);

  useEffect(() => {
    fetchReminders(selectedDate);
  }, [selectedDate, email, deviceType, token]);

  const handleDateSelect = (date) => {
    setSelectedDate(date);
  };

  const handleMonthChange = (firstDayOfMonth) => {
    setCurrentMonth(firstDayOfMonth);
  };

  const getConfig = () => ({
    type: "pregnancy",
    onDateSelect: handleDateSelect,
    onMonthChange: handleMonthChange,
    remainders,
    notes,
  });

  const hasValidReminders = reminderList.some(reminder =>
    reminder.ReminderID && reminder.ReminderTitle && reminder.StartTime && reminder.EndTime
  );

  const handleEditClick = (reminder) => {
    console.log(selectedDate)
    if(selectedDate >= new Date() || selectedDate.toDateString() === new Date().toDateString())
    {
      setEditData({
        isEdit: true,
        reminderId: reminder.ReminderID,
        reminderDate: selectedDate
      });
      setModalOpen(true);
    }
  };

  const handleDeleteClick = (reminder) => {
      setDeletingReminder(reminder);
      setShowDeleteConfirmationModal(true);
    };

    const confirmDelete = async () => {
      setShowDeleteConfirmationModal(false);

      if (!deletingReminder?.ReminderID) return;

      const payload = {
        ReminderID: deletingReminder.ReminderID,
        EmailID: email,
        DeviceType: deviceType,
      };

      try {
        const response = await axios.post(
          Endpoints.DeleteReminder,
          `_Params=${encodeURIComponent(JSON.stringify(payload))}`,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data?.Result === "1") {
          setTimeout(() => {
            toast.success(t("reminderdeletemessage"));
          }, 500);
          setReminderList(prev =>
            prev.filter(r => r.ReminderID !== deletingReminder.ReminderID)
          );
        } else {
          toast.error("Failed to delete reminder");
        }
      } catch (error) {
        console.error(error);
        toast.error("An error occurred while deleting the reminder.");
      } finally {
        setDeletingReminder(null);
      }
    };

  const closeModal = () => {
    setModalOpen(false);
    setEditData(null);
    handleModalClose();
  };

  const handleModalClose = () => {
    fetchMenstrualCycleData(currentMonth);
    fetchReminders(selectedDate);
  };
  const handleBackClick = () => {
    navigate(-1); // Redirects to the home page
  };

   if (loading) {
    return (
      <div className="loading-container">
        <div className="loading"></div>        
        <h2 className="loading-text">{t("loading")}</h2>
      </div>
    );
  }

return(
    <>
        {isHighmarkPortal ? 
          <div className="col-md-12 col-lg-6 mt-4 d-flex inner-page-heading-wrapper">
          <button className="win-back-btn" onClick={handleBackClick}>
              <span>
              <i className="bi bi-chevron-left"></i>
              </span>
          </button>       
          <h2 className="page-headinggg">{t('PregnancySymptomTracker')}</h2>
          </div>:
          <div className="col-md-12 col-lg-6 mt-4 d-flex inner-page-heading-wrapper">
          <button className="win-back-btn" onClick={handleBackClick}>
              <span>
              <i className="bi bi-chevron-left"></i>    
              {t('Back')}        
              </span>
          </button>       
          <h2 className="page-heading">{t('PregnancySymptomTracker')}</h2>
          </div>
      }
    {/* <div className="col-md-6 mt-4 inner-page-heading-wrapper">
        <button className="win-back-btn" onClick={handleBackClick}><span><i class='bi bi-chevron-left'></i> {t('back')}</span></button>
        <h2 className="page-heading">{t("PregnancySymptomTracker")}</h2>
      </div> */}
      <div className="col-md-12 mt-1 d-flex flex-column justify-content-center align-items-center fertility-tracker-buttons-wrapper" >
      
        <div className="col-md-6 mt-1 mb-3 d-flex justify-content-center flex-sm-row flex-column align-items-center fertility-tracker-buttons-wrapper">
        {/* <button className="win-back-btn mt-4 me-2" onClick={handleBackClick}><span><i class='bi bi-chevron-left'></i> Back</span></button> */}
        <TrackerButtons
          isPastDate={selectedDate < new Date()}
          isToday={selectedDate.toDateString() === new Date().toDateString()}
          isFutureDate={selectedDate > new Date()}
          trackerType="pregnancy"
          selectedDate={selectedDate}
          onCloseModalCallback={handleModalClose}
          showEditCycle={false} /* No Edit Cycle for Pregnancy */
          showTrends={true} /* Show Trends for Pregnancy */
        />
      </div>
      </div>
      
      <div className="col-md-12 col-lg-4">
        <CalendarComponent config={getConfig()} />
      </div>
        <div className="col-md-2"></div>
      <div className="col-md-6 mt-5 pregnancy-tracker-remainders">
        <h3 className="page-heading-bold remainders-heading">{t("MyReminders")}</h3>
        <div className="reminders-wrapper mt-md-5">
          {hasValidReminders ? (
            reminderList.sort((a, b) => a.StartTime - b.StartTime).map((reminder, index) => (
              <div key={index} className="reminder-card">
                <h4 className="reminder-appointment-name">{reminder.ReminderTitle}</h4>
                <h4 className="reminder-appointment-datetime">{t("StartDate")}: {(() => {
                  // Format date as mm/dd/yyyy
                  const dateObj = reminder.StartTime;
                  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
                  const date = String(dateObj.getDate()).padStart(2, '0');
                  const year = dateObj.getFullYear();
                  const formattedDate = `${month}/${date}/${year}`;
                  // Check if time is 00:00:00
                  const hours = dateObj.getHours();
                  const minutes = dateObj.getMinutes();
                  const seconds = dateObj.getSeconds();
                  if (hours === 0 && minutes === 0 && seconds === 0) {
                    // Show only date
                    return formattedDate;
                  } else {
                    // Show date and time
            const formattedTime = dateObj.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });                    
                    return `${formattedDate}, ${formattedTime}`;
                  }
                })()}</h4>
                  <FaEdit onClick={() => handleEditClick(reminder)} className="reminder-edit-icon" />
                  <FaTrash onClick={() => handleDeleteClick(reminder)} className="reminder-delete-icon" />
              </div>
            ))
          ) : (
            <div className="no-reminders-set">{t("Youhavenotsetanyreminders")}</div>
          )}
        </div>
      </div>
      <RemainderModal 
        isOpen={isModalOpen} 
        onClose={closeModal} 
        reminderId={editData?.reminderId} 
        reminderDate={editData?.reminderDate} 
        isEdit={editData?.isEdit} 
        onSave={() => fetchReminders(selectedDate)}
      />
      <ErrorModal
        show={showDeleteConfirmationModal}
        onClose={() => setShowDeleteConfirmationModal(false)}
        showConfirmButtons={true}
        message={"Are you sure you want to delete this reminder?"}
        onOkay={confirmDelete}
      />
    </>
  );
}
export default Pregnancy;
